export enum InvoiceCategoriesEnum { // Used For Bom Items Status and GRN
    EPCG = 'EPCG',
    IGST = 'IGST',
    REGULAR = 'REGULAR',
}